import { NextRouter } from 'next/router';
import { FeaturedModel } from 'modules/Explore/types';
import { handleOpenInPlayground } from 'modules/Models/components/ModelViewer/New/Components/utils';
import {
  IconDeepSeek,
  IconGoogle,
  IconClarifai,
  IconMeta,
  IconMistral,
  IconOpenAI,
  IconQwen,
  IconMicrosoft,
  IconOpenbmb,
  IconGrok,
  IconAnthropic,
  IconCohere,
} from 'components/Icons';

import { IconProps } from 'components/Icons/IconProps';
import { FunctionComponent } from 'react';

export const isFeaturedModel = true;

export const navigateToPlayground = (model: FeaturedModel | CF.API.Models.Model, router: NextRouter) =>
  handleOpenInPlayground(model as CF.API.Models.Model, router);

export const navigateToCommunityPage = (
  entity: FeaturedModel | CF.API.Models.Model | CF.API.Workflows.Workflow,
  entitytype: 'model' | 'workflow',
  router: NextRouter,
) => {
  if (!entity) return;

  const { user_id, app_id, id } = entity;

  router.push({ pathname: `/${user_id}/${app_id}/${entitytype}s/${id}` });
};

export type SortOption<T> = {
  name?: string;
  value: T;
};

export type SortKey = 'sort_by_modified_at' | 'sort_by_created_at' | 'sort_by_id';

export const appSortCriteria: { name: string; value: SortKey }[] = [
  { value: 'sort_by_modified_at', name: 'Last Updated' },
  { value: 'sort_by_created_at', name: 'Last Created' },
  { value: 'sort_by_id', name: 'Model Name' },
];

export const sortFunctions: Record<SortKey, (a: CF.API.Models.Model, b: CF.API.Models.Model) => number> = {
  sort_by_modified_at: (a, b) => new Date(b?.modified_at ?? 0)?.getTime() - new Date(a?.modified_at ?? 0)?.getTime(),
  sort_by_created_at: (a, b) => new Date(b?.created_at)?.getTime() - new Date(a?.created_at)?.getTime(),
  sort_by_id: (a, b) => a?.id?.localeCompare(b.id),
};

export const viewAllCategoryModels = (router: NextRouter, useCase?: string) => {
  router.push({
    pathname: '/explore/models',
    query: {
      filterData: JSON.stringify([{ field: 'use_cases', value: [useCase] }]),
      page: '1',
      perPage: '24',
    },
  });
};

export const viewAllWorkflows = (router: NextRouter) => {
  router.push({ pathname: '/explore/workflows' });
};

interface IconLogoMap {
  [key: string]: FunctionComponent<IconProps>;
}

export const accountLogoMap: IconLogoMap = {
  anthropic: IconAnthropic,
  clarifai: IconClarifai,
  'deepseek-ai': IconDeepSeek,
  gcp: IconGoogle,
  openai: IconOpenAI,
  cohere: IconCohere,
  openbmb: IconOpenbmb,
  meta: IconMeta,
  microsoft: IconMicrosoft,
  mistralai: IconMistral,
  qwen: IconQwen,
  xai: IconGrok,
};

/* eslint-disable @typescript-eslint/no-explicit-any */
export const mergeCardsWithConfigAndIcons = (cards: any[]): any[] => {
  return cards.map((card) => ({
    ...card,
    iconComponent: accountLogoMap[card.user_id],
  }));
};
